export default {
    general: {
        person: 'Персона',
        role: 'Роль',
        quit: 'Выйти',
        search: 'Поиск',
        cancel: 'Отмена',
        reset: 'Сбросить',
        next: 'Далее',
        back: 'Назад',
        selectCert: 'Выбрать сертификат',
        print: 'Печать',
        dealer: 'Налогоплательщик',
        inspector: 'Налоговый инспектор',
        admin: 'Администратор',
        actions: 'Действия',
        details: 'Подробнее',
        additional: 'Дополнительно',
        hide: 'Скрыть',
        name: 'Название',
        create: 'Создать',
        createNew: 'Создать новый',
        add: 'Добавить',
        edit: 'Редактировать',
        save: 'Сохранить',
        iin: 'ИИН',
        iinbin: 'ИИН/БИН',
        select: 'Выберите значение',
        taxpayerCabinet: 'Вы находитесь в кабинете налогоплательщика',
        attachment: 'Вложение',
        smsCode: 'SMS код',
        smsCodeSended: 'На номер {0} отправлен SMS код, который необходимо ввести здесь для завершения регистрации и получения сертификата.',
        authSuccess: 'Вы успешно прошли аутентификацию!',
        pressToDownload: 'Если сертификат не загрузился автоматически, нажмите',
        here: 'здесь',
        pressToLogin: 'Нажмите "{0}" для входа с использованием сертификата.',
        haveNcaCert: 'У меня есть сертификат НУЦ РК',
        noData: 'Нет данных, выполните поиск',
        enterValue: 'Введите для поиска',
        fromDate: 'C',
        toDate: 'По',
        lastDay: 'За последний день',
        last12Hours: 'За последние 12 часов',
        lastHour: 'За последний час',
        nextPage: 'След. страница',
        prevPage: 'Пред. страница',
        download: 'Скачать',
        sendLetter: 'Написать письмо',
        yes: 'Да',
        no: 'Нет',
        selectFile: 'Выберите файл',
        fileSizeMessage: 'Размер файла не должен превышать 500 KB',
        useDefaultValue: 'Использовать значение по умолчанию',
        goTo: 'Перейти к ...'
    },
    menu: {
        home: 'АРМ',
        login: 'Вход',
        help: 'Помощь',
        reports: 'Отчеты',
        createReport: 'Создать отчет',
        reportDetails: 'Детали отчета',
        reportViewLog: 'История просмотров',
        profile: 'Профиль',
        dealers: 'Налогоплательщики',
        dealerDetails: 'Кабинет налогоплательщика',
        createDealer: 'Добавить налогоплательщика',
        editDealer: 'Редактирование налогоплательщика',
        persons: 'Персоны',
        audit: 'Аудит',
        addressInfo: 'Адресная информация',
        attributes: 'Параметры',
        systemAttributes: 'Системные параметры',
        kkmAttributes: 'Параметры ККМ',
        editAttribute: 'Редактирование параметра',
        createPerson: 'Добавить персону',
        editPerson: 'Редактировать персону',
        tickets: 'Чеки',
        ticketDetails: 'Детали чека',
        sellReturn: 'Возврат',
        moneyPlacements: 'Инкассации/пополнения',
        moneyPlacementDetails: 'Детали инкассации/пополнения',
        kkms: 'ККМ',
        blockedKkms: 'Заблокированные ККМ',
        createKkm: 'Создание ККМ',
        editKkm: 'Редактирование ККМ',
        setOfdData: 'Установить данные ОФД',
        startFiscalization: 'Старт фискализации',
        stopFiscalization: 'Стоп фискализации',
        setCashier: 'Установка кассира по умолчанию',
        revokeCert: 'Отзыв сертификата',
        setDealer: 'Привязка налогоплательщика',
        setBlockStatus: 'Блокировка/Разблокировка ККМ',
        setOfdUnblock: 'Разблокировка по данным ОФД',
        setOfdWork: 'Перевод в рабочее состояние',
        setPoint: 'Установка точки продаж',
        setMode: 'Установка режима',
        changePassword: 'Изменение пароля',
        setCanChangePublicKey: 'Установка признака регистрации публичного ключа',
        closeCcm: 'Остановить работу ККМ',
        createMoneyPlacement: 'Создать инкасацию или пополнение',
        tasks: 'Задачи'
    },
    role: {
        '1': 'Администратор',
        '3': 'Налогоплательщик',
        '4': 'Налоговый инспектор',
        '5': 'Оператор'
    },
    errors: {
        error: 'Ошибка',
        unknownError: 'Возникла непредвиденная ошибка, обратитесь в службу поддержки.',
        selectDealer: 'Для просмотра ККМ необходимо выбрать налогоплательщика.',
        cantGetDealerInfo: 'Не удалось получить информацию о налогоплательщике, попробуйте войти снова.',
        cantGetUserInfo: 'Не удалось получить информацию о Вашей персоне, попробуйте войти снова.',
        passwordDontMatch: 'Пароли не совпадают',
        passwordNotValid: 'Пароль не подходит по требованиям системы',
        taxorgIdMustBeSet: 'Необходимо указать название налоговой инспекции',
        addressMustBeSet: 'Необходимо указать полный адрес',
        '1': 'Неизвестная ошибка',
        '2': 'Ошибка проверки сигнатуры',
        '3': 'Заданный логин не найден (нет соответствующего сертификата). Тип авторизации изменён на "Пароль"',
        '4': 'Неверный сертификат (не проходит проверка сигнатуры)',
        '5': 'Пустые поля в запросе',
        '6': 'Сертификат с указанным логином уже есть в криптосервисе (необходим отзыв) или сертификат недействителен',
        '101': 'Ошибка доступа',
        '102': 'Не все обязательные параметры переданы для выполнения функции',
        '103': 'Смена c указанным номером не найдена',
        '104': 'Отсутствует открытая смена',
        '105': 'Смена уже открыта',
        '106': 'Транзакция с идентификатором уже есть в системе',
        '107': 'Транзакция не найдена в системе',
        '108': 'Транзакция уже отменена',
        '109': 'Недостаточно средств в кассе для выполнения транзакции',
        '110': 'Нарушение логики переданных данных',
        '111': 'Идентификатор не найден',
        '112': 'Транзакция проведена',
        '113': 'Статус ККМ не позволяет выполнить операцию',
        '114': 'Превышен период работы в автономном режиме',
        '116': 'Имеется открытая смена',
        '201': 'Неправильный логин или пароль',
        '202': 'Пользователь заблокирован',
        '203': 'Авторизация Превышено количество с неверным паролем',
        '204': 'Неправильный логин или пароль',
        '205': 'Пользователь уже существует в системе',
        '206': 'Пользователь не существует',
        '207': 'Авторизация должна быть по крипто-ключу',
        '208': 'Не прошла проверка подписи по крипто-ключу',
        '209': 'Не верный SMS код',
        '210': 'Истек срок действия токена',
        '211': 'Не верно передан токен',
        '301': 'Дилер уже есть в системе',
        '302': 'ККМ уже присвоен регистрационный номер',
        '303': 'Фискализация ККМ уже запущена',
        '304': 'Фискализация ККМ уже остановлена',
        '305': 'Дилер не найден',
        '306': 'ККМ уже существует',
        '307': 'Налоговая инспекция не найдена',
        '308': 'Операция запрещена. ККМ не подключен к ОФД',
        '309': 'ККМ не находится в режиме программирования. Выполнение операции запрещено',
        '310': 'ККМ находится в режиме программирования. Выполнение операции запрещено',
        '311': 'Перевести ККМ в рабочий режим может только пользователь, установивший режим программирования',
        '401': 'Неверно указан тип отчета',
        '402': 'Идентификатор задачи указан не верно',
        '403': 'Ошибка доступа',
        '404': 'Страница не найдена',
        '405': 'Статус задачи не позволяет выполнить операцию',
        '406': 'Отчет по данной задаче уже добавлен в базу',
        '407': 'Операция заблокирована задачей',
        '408': 'Контрольные суммы Z отчета и чеков не верны',
        '409': 'Количество чеков в Z отчете не соответствует реальным данным',
        '410': 'Необнуляемые суммы на начало смены не соответствуют суммам на конец предыдущей смены',
        '411': 'Обороты по смене не соответствуют оборотам по чекам',
        '604': 'Криптосервис: Сервер недоступен или данные сформированы некорректно',
        '607': 'Криптосервис: Не найден алиас (логин) в хранилище сертификатов',
        '608': 'Криптосервис: Сертификаты не совпадают',
        '999': 'Нестандартная исключительная ситуация. Необходимо выяснить причину. См. логи.'
    },
    report: {
        type: 'Тип отчета',
        types: {
            default: 'Отчет',
            REPORT_Z: 'Z-отчет',
            Z_REPORT: 'Z-отчет',
            X_REPORT: 'X-отчет',
            REPORT_X: 'X-отчет',
            FISCAL_PERIOD_REPORT: 'Фискальный отчет за период',
            FISCAL_PERIOD_REPORT_V2: 'Фискальный отчет за период',
            CASHIER_REPORT: 'Отчет по кассирам',
            SECTION_REPORT: 'Отчет по секциям'
        },
        viewLog: {
            viewDate: 'Дата и время просмотра отчета'
        },
        createDate: 'Дата создания',
        shiftNumber: 'Номер смены',
        shiftOpenDate: 'Дата и время открытия смены',
        shiftCloseDate: 'Дата и время закрытия смены',
        operations: 'Итоги по операциям суммарно по всем отделам',
        bySections: 'Отчет по секциям',
        section: 'Секция',
        totalResults: 'Окончательные итоги по операциям',
        moneyPlacements: 'Итоги по операциям с наличными',
        withdrawal: 'Выплат',
        deposit: 'Внесений',
        buy: 'Покупка',
        buyReturn: 'Возврат покупки',
        sell: 'Продажа',
        sellReturn: 'Возврат продажи',
        count: 'Количество',
        sum: 'Сумма',
        fromDate: 'Начало периода',
        toDate: 'Окончание периода',
        viewHistory: 'История просмотров',
        createdMessage: 'Задача на формирование отчета успешно создана.',
        tax: 'Налог',
        taxTurnover: 'Оборот по налогу',
        taxType: {
            NDS: 'НДС'
        },
        reportWithDamping: 'Отчет с гашением',
        reportWithoutDamping: 'Отчет без гашения',
        startShiftNonNullableSums: {
            buy: 'Необнуляемая сумма покупок на начало смены',
            buyReturn: 'Необнуляемая сумма возвр. покупок на начало смены',
            sell: 'Необнуляемая сумма продаж на начало смены',
            sellReturn: 'Необнуляемая сумма возвр. продаж на начало смены'
        },
        closeShiftNonNullableSums: {
            buy: 'Необнуляемая сумма покупок',
            buyReturn: 'Необнуляемая сумма возвр. покупок',
            sell: 'Необнуляемая сумма продаж',
            sellReturn: 'Необнуляемая сумма возвр. продаж'
        },
        ticketOperations: {
            buy: 'Чеков покупок',
            buyReturn: 'Чеков возвратов покупок',
            sell: 'Чеков продаж',
            sellReturn: 'Чеков возвратов продаж'
        },
        paymentType: {
            cash: 'Наличными',
            card: 'Платежной картой',
            credit: 'Кредитом',
            tare: 'Тарой'
        },
        cashSum: 'Наличных в кассе',
        revenue: 'Выручка',
        canceledTickets: 'Аннулированных чеков',
        byShifts: 'Отчет по сменам',
        shift: 'Смена',
        cashier: 'Кассир',
        kkmFactoryNum: 'Заводской номер ККМ',
        discounts: 'Итоги по скидкам',
        markups: 'Итоги по наценкам',
        summaryDiscounts: 'Cумма итогов по скидкам за период',
        summaryMarkups: 'Cумма итогов по наценкам за период',
        summaryOperations: 'Cумма итогов по операциям за период'
    },
    person: {
        lastname: 'Фамилия',
        firstname: 'Имя',
        middlename: 'Отчество',
        fio: 'ФИО',
        phone: 'Телефон',
        login: 'Логин',
        newLogin: 'Новый логин',
        password: 'Пароль',
        newPassword: 'Новый пароль',
        confirmPassword: 'Повторите пароль',
        address: 'Адрес',
        addressCity: 'Адрес (город)',
        addressStreet: 'Адрес (улица)',
        addressHouse: 'Адрес (дом)',
        newAddressCity: 'Новый адрес (город)',
        newAddressStreet: 'Новый адрес (улица)',
        newAddressHouse: 'Новый адрес (дом)',
        selectRole: 'Выберите роль',
        enabled: 'Действует в системе',
        unlimitedTimeoutSession: 'Неограниченное время жизни сессии',
        authType: 'Тип авторизации',
        authTypes: {
            'Password': 'Пароль',
            'Certificate': 'Сертификат',
            'CertificateNca': 'Сертификат НУЦ'
        },
        authKey: 'Сертификат для авторизации',
        regdate: 'Дата регистрации',
        updatedMessage: 'Информация о персоне успешно обновлена',
        certRevokeConfirmation: 'Вы действительно хотите отозвать сертификат пользователя "{0}"?',
        certRevokedMessage: 'Сертификат успешно отозван',
        typeIin: 'Введите ИИН/БИН налогоплательщика',
        dealerSetMessage: 'Налогоплательщик успешно привязан',
        passwordChangedMessage: 'Пароль успешно изменен',
        passwordRequirements: 'Пароль должен содержать не менее 8 символов и состоять из латинских букв, включая заглавные, арабских цифр и спецсимволов из этого списка: @$!%*?&_'
    },
    kkm: {
        id: 'Идентификатор ККМ',
        label: 'ККМ',
        updatedMessage: 'Информация о ККМ успешно обновлена',
        qiwiTerminal: 'Терминал Qiwi Казахстан',
        qiwiTerminalNumber: 'Номер терминала Qiwi Казахстан',
        yes: 'Да',
        no: 'Нет',
        cashierCode: 'Код оператора',
        cashierName: 'Наименование оператора',
        cashierSetMessage: 'Кассир-оператор успешно установлен',
        inspectionName: 'Название налоговой инспекции',
        inspectionCode: 'Код налоговой инспекции',
        registration: 'Регистрационный номер',
        identification: 'Идентификационный номер',
        factoryNum: 'Заводской номер',
        timezone: 'Временная зона ККМ',
        cashAmount: 'Текущий остаток по кассе',
        kkmSfdNum: 'Идентификатор KKM в СФД',
        enabled: 'Подключен к СФД',
        ofdConnected: 'Подключен к ОФД',
        openDate: 'Дата начала действия ККМ',
        closeDate: 'Дата окончания действия ККМ',
        created: 'Создан',
        startFiscalDate: 'Дата и время начала фискализации',
        kkmId: 'Идентификатор в ОФД',
        ofdToken: 'Токен ОФД',
        ofdSelectString: 'Оператор ОФД',
        selectOfdConnection: 'Выберите оператора ОФД',
        ofdConnectionString: 'Строка подключения к ОФД',
        publicKey: 'Публичный ключ ККМ',
        canChangePublicKey: 'Возможность изменить публичный ключ ККМ',
        defaultOperator: 'Оператор по умолчанию',
        isBlocked: 'Заблокирован',
        blocked: 'Признак блокировки',
        blockStatusSetMessage: 'Статус блокировки успешно изменен',
        pointTitle: 'Наименование точки продажи',
        pointAddress: 'Адрес точки продажи',
        pointAddressCity: 'Адрес точки продажи (город)',
        pointAddressStreet: 'Адрес точки продажи (улица)',
        pointAddressHouse: 'Адрес точки продажи (дом)',
        status: 'Статус',
        blockDate: 'Дата блокировки',
        blockMessage: 'Комментарий блокировки',
        ofdStatus: 'Статус ОФД',
        ofdBlockDate: 'Дата блокировки ОФД',
        ofdBlockMessage: 'Комментарий блокировки ОФД',
        register: 'Регистрация',
        unregister: 'Снятие с регистрации',
        comment: 'Комментарий',
        createdMessage: 'ККМ успешно создан. Идентификатор: {0}',
        ofdDataSetMessage: 'Токен ОФД успешно сохранен.',
        toKkmList: 'К списку ККМ',
        pointSetMessage: 'Точка продажи успешно установлена',
        setOfdWorkConfirmation: 'ККМ {0} будет переведен в рабочее состояние.',
        ofdWorkSetMessage: 'ККМ успешно переведен в рабочее состояние.',
        mode: 'Режим',
        programMode: 'Режим программирования',
        programModeUserLabel: 'Выполнено',
        workMode: 'Режим продаж',
        programTask: 'Переход',
        programModeSetMessage: 'Режим программирования успешно установлен',
        workModeSetMessage: 'Режим продаж успешно установлен',
        statusOfdShortName: {
            'READY': 'Онлайн',
            'BLOCKED': 'Заблокирован',
            'ERROR': 'Ошибка',
            'ERROR_TEMP': 'Автономный режим',
            'WAIT_OFD_CONFIRM': 'Подтверждение регистрационных данных'
        },
        statusOfdFullName: {
            'READY': 'В рабочем состоянии',
            'BLOCKED': 'Заблокирован в ОФД',
            'ERROR': 'Остановлен, требуется вмешательство специалиста',
            'ERROR_TEMP': 'Остановлен (временная ошибка)',
            'WAIT_OFD_CONFIRM': 'Подтверждение регистрационных данных'
        },
        statusShortName: {
            'CREATED': 'Создан',
            'READY': 'В работе',
            'WAIT_OFD': 'Ожидание данных ОФД',
            'STOP': 'Снят с учета',
            'CLOSED': 'Закрыт'
        },
        statusFullName: {
            'CREATED': 'Создан в системе',
            'READY': 'В рабочем состоянии',
            'WAIT_OFD': 'Ожидание данных ОФД',
            'STOP': 'Снят с учета',
            'CLOSED': 'Работа ККМ в системе завершена'
        },
        clientStatus: 'Статус терминала',
        clientStatusMessage: 'Информация о статусе терминала',
        clientStatusDate: 'Дата изменения статуса терминала',
        setCanChangePublicKeyConfirmText: 'Вы действительно хотите установить признак регистрации публичного ключа?',
        setCanChangePublicKeySuccess: 'Признак регистрации публичного ключа установлен',
        closeCcmConfirmText: 'Вы действительно хотите остановить работу ККМ с идентификатором СФД = {0}?',
        ccmCloseSuccess: 'Работа KKM с идентификатором СФД = {0} успешно остановлена',
        required: 'Необходимо указать ККМ',
        ofdDataRequirement: 'Числовое значение должно находиться в диапазоне от 0 до 4294967295'
    },
    ticket: {
        shiftDocumentNumber: 'Номер чека в смене',
        offlineTicketNumber: 'Автономный номер чека',
        onlineTicketNumber: 'Фискальный номер чека',
        debet: 'Приход/расход по ККМ',
        income: 'Приход',
        expense: 'Расход',
        totalAmount: 'Сумма чека',
        status: 'Состояние чека',
        cashierName: 'Кассир-оператор',
        txnClientDate: 'Дата транзакции в ККМ',
        operationTypes: {
            default: 'Тип операции',
            SELL: 'Продажа'
        },
        itemName: 'Название',
        section: 'Отдел',
        quantity: 'Количество',
        price: 'Цена',
        total: 'Сумма',
        taken: 'Принято',
        change: 'Сдача',
        sellReturnConfirmation: 'Вы действительно хотите сделать возврат по чеку {0}?',
        sellReturnedMessage: 'Задача на возврат по чеку успешно создана.',
        shiftNumber: 'Номер смены',
        kkmFactoryNum: 'Заводской номер ККМ'
    },
    task: {
        userLogin: 'Логин пользователя',
        creationTime: 'Дата создания',
        creator: 'Создал',
        status: 'Статус',
        type: 'Тип',
        completionTime: 'Время завершения выполнения',
        parameters: 'Параметры',
        result: 'Результат',
        ccmSfdNumber: 'Идентификатор ККМ в СФД',
        errorMessage: 'Сообщение об ошибке',
        state: 'Промежуточное состояние',
        notCompleted: 'Выполняется',
        types: {
            ZReport: 'Z-отчет',
            XReport: 'X-отчет',
            FiscalPeriodReport: 'Фискальный отчет за период',
            CashierReport: 'Отчет по кассирам',
            SectionReport: 'Отчет по секциям',

            SellReturn: 'Возрат',
            WithdrawMoney: 'Инкасация',
            DepositMoney: 'Пополнение',

            ProgramMode: 'Перевод в режим программирования'
        },
        statuses: {
            Success: 'Выполнена',
            Running: 'Выполняется',
            Pending: 'В ожидании',
            Error: 'Ошибка'
        },
        goToReport: 'Перейти к отчету',
        goToWithdrawMoney: 'Перейти к инкасации',
        goToDepositMoney: 'Перейти к пополнению'
    },
    moneyPlacement: {
        shiftDocumentNumber: 'Порядковый номер в смене',
        shiftNumber: 'Номер смены',
        debet: 'Приход/расход по ККМ',
        amount: 'Сумма пополнения/инкассации',
        txnClientDate: 'Дата транзакции в ККМ',
        collection: 'Инкассация',
        replenishment: 'Пополнение',
        sumOfCollection: 'Сумма инкассации',
        sumOfReplenishment: 'Сумма пополнения',
        kkmFactoryNum: 'Заводской номер ККМ',
        withdrawTaskHasBeenCreated: 'Задача на инкасацию успешно создана',
        depositTaskHasBeenCreated: 'Задача на пополнение успешно создана'
    },
    dealer: {
        name: 'Наименование',
        industry: 'Вид деятельности',
        updatedMessage: 'Информация о налогоплательщике успешно обновлена',
        regDateTime: 'Дата регистрации',
        phone: 'Номер телефона',
        address: 'Адрес',
        addressCity: 'Адрес (город)',
        addressStreet: 'Адрес (улица)',
        addressHouse: 'Адрес (дом)',
        newAddressCity: 'Новый адрес (город)',
        newAddressStreet: 'Новый адрес (улица)',
        newAddressHouse: 'Новый адрес (дом)',
        ndsPayer: 'Является плательщиком НДС',
        ndsCertificateSeries: 'Серия свидетельства НДС',
        ndsCertificateNum: 'Номер свидетельства НДС'
    },
    audit: {
        dateTime: 'Дата',
        event: 'Событие',
        sysObject: 'Объект',
        subject: 'Логин субъекта',
        success: 'Успех',
        yes: 'Да',
        no: 'Нет'
    },
    attribute: {
        code: 'Код атрибута',
        value: 'Значение',
        comment: 'Комментарий',
        updatedMessage: 'Системный параметр успешно обновлен'
    },
    addressInfo: {
        operationType: 'Тип операции',
        selectType: 'Выберите тип объекта, который Вы хотите {0}',
        area: 'Область',
        district: 'Район области',
        city: 'Город',
        cityDistrict: 'Район города',
        microDistrict: 'Микрорайон',
        street: 'Улица',
        house: 'Дом',
        newValue: 'Новое значение',
        addressCreatedMessage: 'Адрес успешно добавлен',
        addressUpdatedMessage: 'Адрес успешно обновлен'
    },
    staticPages: {
        helpText: 'Если у Вас возникли дополнительные вопросы по работе системы, просим связаться с нами.'
    },
    version: {
        client: 'Версия клиента',
        server: 'Версия сервера'
    }
}
